/* <wg-shipping-bar data-progress="0..1">
   Free-delivery progress in the cart drawer. The drawer's HTML is re-rendered on
   every cart change, so each new instance starts from the previously shown value
   (remembered on window) and eases to its own value — filling and de-filling
   smoothly instead of jumping. */
(function () {
  if (customElements.get('wg-shipping-bar')) return;

  class WGShippingBar extends HTMLElement {
    connectedCallback() {
      var target = Math.min(1, Math.max(0, parseFloat(this.getAttribute('data-progress')) || 0));
      var previous = typeof window.__wgShippingProgress === 'number' ? window.__wgShippingProgress : 0;

      /* Start where the last render left off, then transition to the new value */
      this.style.setProperty('--wg-ship-progress', previous.toFixed(4));
      this.classList.remove('is-animating');
      /* force style flush so the transition has a starting point */
      void this.offsetWidth;

      var self = this;
      requestAnimationFrame(function () {
        self.classList.add('is-animating');
        self.style.setProperty('--wg-ship-progress', target.toFixed(4));
        if (target >= 1 && previous < 1) {
          self.classList.add('just-unlocked');
          setTimeout(function () {
            self.classList.remove('just-unlocked');
          }, 1600);
        }
      });

      window.__wgShippingProgress = target;
    }
  }

  customElements.define('wg-shipping-bar', WGShippingBar);
})();
